import React from "react"
import { useIntl } from "react-intl"
import { ExclamationCircleFill } from "@walmart-web/livingdesign-icons"

import Button from "components/Shared/Button"
import { validateCriteria } from "helpers/password"
import PasswordCriteria from "components/ResetPassword/ResetPasswordForm/PasswordCriteria"
import PasswordInput from "./PasswordInput"
import { ChangePasswordResult, changePw } from "./service"
interface ChangePasswordFormProps {
	setChangePasswordResult: (result: ChangePasswordResult) => void
}

const ChangePasswordForm: React.FC<ChangePasswordFormProps> = ({
	setChangePasswordResult,
}) => {
	const intl = useIntl()
	const [oldPassword, setOldPassword] = React.useState("")
	const [newPassword, setNewPassword] = React.useState("")
	const [confirmPassword, setConfirmPassword] = React.useState("")
	const [criteria, setCriteria] = React.useState(validateCriteria(""))
	const [isSubmitting, setIsSubmitting] = React.useState(false)
	const [
		confirmPasswordErrorFlag,
		setConfirmPasswordErrorFlag,
	] = React.useState(false)

	const criteriaMet = Object.values(criteria).every((value) => value)
	const validForm = criteriaMet && newPassword === confirmPassword

	React.useEffect(() => {
		if (newPassword.length) {
			setCriteria(validateCriteria(newPassword))
		}
	}, [newPassword])

	React.useEffect(() => {
		if (confirmPassword.length) {
			setConfirmPasswordErrorFlag(newPassword !== confirmPassword)
		}
		setConfirmPasswordErrorFlag(false)
	}, [confirmPassword])

	const handleSubmit: React.FormEventHandler<HTMLFormElement> = async (
		e: React.FormEvent<HTMLFormElement>
	) => {
		e.preventDefault()
		setIsSubmitting(true)
		const response = await changePw(oldPassword, newPassword)
		setChangePasswordResult(response)
	}

	const showError = (showMessage: boolean, text: string) => {
		return (
			showMessage && (
				<div>
					<ExclamationCircleFill className="error-icon" />
					<span className="error-text">
						{intl.formatMessage({
							id: text,
						})}
					</span>
				</div>
			)
		)
	}

	return (
		<form className="form-container" onSubmit={handleSubmit}>
			<PasswordInput
				label="phronesis.configuration.change-password.current-credential"
				value={oldPassword}
				onChange={setOldPassword}
				id="old-password"
			/>
			<PasswordInput
				label="phronesis.configuration.change-password.new-credential"
				value={newPassword}
				onChange={setNewPassword}
				disabled={!oldPassword.length}
				id="new-password"
			/>
			<PasswordCriteria criteriaErrors={criteria} />
			<PasswordInput
				label="phronesis.configuration.change-password.confirm-credential"
				value={confirmPassword}
				onChange={setConfirmPassword}
				disabled={!criteriaMet}
				id="confirm-password"
			/>
			{showError(
				confirmPasswordErrorFlag,
				"phronesis.configuration.change-password.error.different-password"
			)}
			<Button
				disabled={!validForm || isSubmitting}
				variant="primary"
				size="large"
				type="submit"
				className="submit-button"
			>
				{intl.formatMessage({
					id: "phronesis.configuration.change-password.submit",
				})}
			</Button>
		</form>
	)
}

export default ChangePasswordForm
